package com.iregained.eventapp.components.sections.admin_dashboard.styles

import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import org.jetbrains.compose.web.css.px

val AdminSidebarStyle = CssStyle.base {
    Modifier
        .width(250.px)
        .fillMaxHeight()
        .padding(24.px)
}

val KanbanColumnStyle = CssStyle.base {
    Modifier
        .borderRadius(8.px)
        .padding(16.px)
        .fillMaxWidth()
}

val PatientCardStyle = CssStyle.base {
    Modifier
        .fillMaxWidth()
        .borderRadius(6.px)
        .padding(16.px)
        .margin(bottom = 12.px)
        .cursor(Cursor.Pointer)
}